import { getSliceSubdomain } from "."
import { ProductCart } from "./cart/cartProductTypes"

export function sendMessage(
  chainId: number,
  cart: ProductCart[],
  buyer: string,
  slicerId: number,
  receiver: string | undefined
) {
  const formattedBuyer =
    buyer.slice(0, 2) === "0x"
      ? buyer.slice(0, 6) + "..." + buyer.slice(-4)
      : buyer

  fetch(
    `https://${getSliceSubdomain(chainId)}slice.so/api/send_base_messages`,
    {
      method: "POST",
      body: JSON.stringify({
        buyer: formattedBuyer,
        cart,
        slicerIdAndReceiver: receiver ? `${slicerId}-${receiver}` : undefined
      })
    }
  )
}
